import { createAction, Dispatch } from '@reduxjs/toolkit';
import api from '../../../api';
import { ValidationProcess, ValidationRuleType } from '../types';

const VALIDATE = 'VALIDATE';
const VALIDATE_LOADING = 'VALIDATE_LOADING';

export const validateLoadingAction = createAction<{ isLoading: boolean }>(VALIDATE_LOADING);
export const validateAction = createAction<{
  isLoading: boolean;
  values?: Record<ValidationProcess, ValidationRuleType[] | undefined>;
}>(VALIDATE);

export function validateEntryForm(entryForm: any) {
  return async (dispatch: Dispatch) => {
    dispatch(validateLoadingAction({ isLoading: true }));

    try {
      const resp = await api.validationRule.validate(entryForm);
      dispatch(validateAction({ isLoading: false, values: resp.data }));
    } catch (e) {
      dispatch(validateAction({ isLoading: false }));
    }
  };
}
